<template lang="pug">
  .modal
    header.header-area シミュレーション保存
    .content_name-simulation(v-if="!checkConfirm && !checkConfirmEmail")
      div
        p 保存するシミュレーションの名前を入力ください。
      div.area-content
        label.save シミュレーション名（必須）
        input.save-input(v-model="simulation.name", placeholder="シミュレーション名" required)
    .area-content-email(v-if="checkConfirm || (!checkConfirmEmail && email)")
      label.email メールアドレス（任意）
      input.email-input(v-model="email", type="email", for="email")
      span.text-error(v-if="errorEmail") メールアドレスが正しくありません。
    .area-content-email(v-if="checkId")
      p 復元用のIDは
        <span class="code"> {{ code }} </span>です。<br>IDを指定のアドレスに送信する場合は、<br>「メールアドレス入力」ボタンからご登録ください。<br>※IDを忘れた場合は復元できませんので、IDは大切に保管ください。
    .content_name-simulation.confirm-email(v-if="checkConfirmEmail")
      div
        p こちらのメールアドレスに送信します。
      div.area-content
        p.save {{ email}}
    footer
      button.close(@click="close", v-if="checkConfirm && !checkConfirmEmail")
        | 閉じる
      button(@click="save", v-if="!checkId && !checkConfirm && !checkConfirmEmail")
        | 保存
        img(src="@/assets/ico_arrow_right.svg")
      button(@click="saveId", v-if="checkId")
        | メールアドレス入力
        img(src="@/assets/ico_arrow_right.svg")
      button(@click="confirm", v-if="checkConfirm || (!checkConfirmEmail && email)")
        | 確認
        img(src="@/assets/ico_arrow_right.svg")
      button.close(@click="back", v-if="checkConfirmEmail && email")
        | 戻る
      button(@click="submit", v-if="checkConfirmEmail && email")
        | 送信
</template>
<script>
export default {
  name: 'SaveInput',
  data () {
    return {
      simulation: {
        id: Math.floor(Math.random() * 1000000) + 1,
        name: '',
        email: '',
        sets: [],
        msg: []
      }
    };
  },
  props: {
    checkConfirm: Boolean,
    checkConfirmEmail: Boolean,
    checkId: Boolean,
    errorEmail: Boolean,
    code: String
  },
  methods: {
    save () {
      this.$emit('save', { simulations: this.simulation });
    },
    saveId () {
      this.$emit('saveId');
    },
    close () {
      this.$emit('close');
    },
    confirm () {
      this.$emit('confirm');
    },
    back () {
      this.$emit('back');
    },
    submit () {
      this.$emit('submit', { email: this.email, code: this.code });
    }
  }
};
</script>

<style lang="stylus" scoped>
.modal
  .header-area
    margin: 0;
    padding: 20px 30px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #dddddd;
  .area-content
    display: flex;
    align-items: center;
    padding: 10px 30px;
    position: absolute;
    left: 0;
    right: 0;
    top: 72px;
    bottom: 73px;
    overflow-y: auto;
    label
      font-size: 18px;
      font-weight: bold;
    input
      height: 33px;
      padding: 0 5px;
      font-weight: bold;
      font-size: 16px;
      border 1px solid #ddd;
      border-radius: 2px;
  .content_name-simulation
    display: flex
    flex-direction: column
    padding: 5px 30px
.area-content-email
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 30px;
  background-color: #ffffff;
  position: absolute;
  left: 0;
  right: 0;
  top: 72px;
  bottom: 73px;
  overflow-y: auto;
  .code
    color: #2e7c80;
    font-weight: bold;
    font-size: 20px;
  label
    font-size: 18px;
    font-weight: bold;
  input
    height: 33px;
    padding: 0 5px;
    font-weight: bold;
    font-size: 16px;
    border 1px solid #ddd;
    border-radius: 2px;
.save-simulation
  .vm--modal
    width: 570px !important;
    height: 300px !important;
footer
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 73px;
  padding: 20px 30px;
  border-top: 1px solid #dddddd;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  button
    background-color: #2E7C80;
    width: 180px;
    height: 33px;
    border: none;
    border-radius: 5px;
    color: #ffffff;
    font-weight: bold;
    font-size: 14px;
    margin-left: 15px;
    &[disabled], background-color #aaaaaa, &:hover
      opacity: 1;
    img
      display: inline-block;
      vertical-align: middle;
      margin-left: 5px;
      margin-top: -2px;
  .close
    background-color: #999;
    width: 180px;
    height: 33px;
    border: none;
    border-radius: 5px;
    color: #fff;
    font-weight: bold;
    font-size: 14px;
  .red
    background-color: #fff;
    width: 180px;
    height: 33px;
    border: none;
    border-radius: 5px;
    color: red;
    font-weight: bold;
    font-size: 14px;
    border: 1px solid black;
.text-error
  margin-top: 10px;
  display: inline-block;
  color: red;
</style>



// WEBPACK FOOTER //
// src/components/save/SaveInput.vue